import { Component, ElementRef, OnInit } from '@angular/core';
import { BcFobMPackageComponent } from "../bc-fob-m-package/bc-fob-m-package.component";
import { BcFobMViscosityModifierComponent } from "../bc-fob-m-viscosity-modifier/bc-fob-m-viscosity-modifier.component";
import { BcFobMPpdComponent } from "../bc-fob-m-ppd/bc-fob-m-ppd.component";
import { BcFobMBaseOilComponent } from '../bc-fob-m-base-oil/bc-fob-m-base-oil.component';
import { AllServicesService } from '../../../services/all-services.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { CommonModule } from '@angular/common';
import { LoggerService } from '../../services/logger.service';
import { NotificationFacadeService } from '../../services/notification-facade.service';
import { mapUnknownError } from '../../services/app-error-catalog';

@Component({
  selector: 'app-bc-fob-modification',
  imports: [BcFobMPackageComponent, BcFobMViscosityModifierComponent,
    BcFobMPpdComponent, BcFobMBaseOilComponent, CommonModule],
  templateUrl: './bc-fob-modification.component.html',
  styleUrl: './bc-fob-modification.component.scss'
})
export class BcFobModificationComponent implements OnInit {
  // Shared data that will be fetched from the API
  dropdownData: any = null;
  isLoading: boolean = true;
  error: string | null = null;

  totalRatioP1: number = 0;
  totalTreatP1: number = 0;
  totalRatioP2: number = 0;
  totalTreatP2: number = 0;

  // Tolerance mirrors the prediction ratio gate so 100.00 never flags as over.
  private readonly ratioOverTolerance = 0.0001;

  get isRatioP1Over(): boolean {
    return this.totalRatioP1 - 100 > this.ratioOverTolerance;
  }

  get isRatioP2Over(): boolean {
    return this.totalRatioP2 - 100 > this.ratioOverTolerance;
  }

  constructor(private elementRef: ElementRef,
    private dataService: AllServicesService,
    private sharedService: SharedServiceService,
    private logger: LoggerService,
    private notificationFacade: NotificationFacadeService
  ) { }

  ngOnInit(): void {
    this.loadDropdownData();
    // Subscribe to the totals
    this.sharedService.totalRatioP1$.subscribe(total => {
      this.totalRatioP1 = total;
    });

    this.sharedService.totalTreatP1$.subscribe(total => {
      this.totalTreatP1 = total;
    });

    this.sharedService.totalRatioP2$.subscribe(total => {
      this.totalRatioP2 = total;
    });

    this.sharedService.totalTreatP2$.subscribe(total => {
      this.totalTreatP2 = total;
    });
  }

  loadDropdownData(): void {
    this.isLoading = true;
    this.error = null;

    this.dataService.getdropdown().subscribe({
      next: (response) => {
        this.dropdownData = response;
        this.isLoading = false;
        // Signal that dropdowns are ready so a shared-favorite load can safely apply state.
        this.sharedService.setBlendCalculatorReady(true);
      },
      error: (err) => {
        const appError = mapUnknownError(err, 'loadDropdownData');
        this.error = appError.userMessage;
        this.isLoading = false;
        this.logger.error(appError, { operation: 'loadDropdownData' });
        this.notificationFacade.showError(appError);
        // Unblock any pending shared-favorite load even when dropdowns failed.
        this.sharedService.setBlendCalculatorReady(true);
      }
    });
  }

  scrollToTop() {
    const element = this.elementRef.nativeElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
